import React from 'react';

export default function BillingFaqLink({ ukClient }) {
	if (ukClient) return null;
	return (
		<p>
			We know billing can be complicated. Feel free to check out our{' '}
			<a href="/billing#faq" target="_blank">
				billing FAQs
			</a>{' '}
			prior to submitting your test if you have questions.
		</p>
	);
}
